import React, { useContext } from 'react'
import { ModalActions } from 'components/Modal'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { AutoRenewIcon, Box, Button, Text } from 'vvs-uikit'
import { formatLockPeriod, getEndDate } from 'views/xVvs/helpers'
import Row, { AutoRow } from 'components/Layout/Row'
import { format } from 'date-fns'
import xVvsContext from 'views/xVvs/context'
import BigNumber from 'bignumber.js'
import { formatNumber, getBalanceAmount } from 'utils/formatBalance'
import tokens from 'config/constants/tokens'
import { StyledText } from 'views/xVvs/styles'
import { useVaultsApr } from 'views/xVvs/hooks/useVaultsApr'
import Warning from './Warning'
import DepositAmount from './DepositAmount'
import LockPeriodLogo from '../LockPeriodLogo'

interface ConfirmStepProps {
  pendingTx: boolean
  amount: BigNumber
  onConfirm: () => void
}

const ConfirmStep = ({ pendingTx, onConfirm, amount }: ConfirmStepProps) => {
  const { t } = useTranslation()
  const { state } = useContext(xVvsContext)
  const { selectedPool } = state

  const { theme } = useTheme()

  const vaultsApr = useVaultsApr()
  const apr = vaultsApr.find((pool) => pool.poolId === selectedPool.pid)?.apr || '0'

  const endDate = getEndDate(selectedPool.lockPeriod)

  const formattedAmount = getBalanceAmount(amount, tokens.xvvs.decimals)

  return (
    <Box>
      <Text small>{t('Upgrade to')}</Text>
      <Row align="center" mt={3}>
        <LockPeriodLogo imgSrc={selectedPool.imgSrc} width={42} height={42} />
        <Text fontSize="20px" ml={3}>
          {formatLockPeriod(selectedPool.lockPeriod)}
        </Text>
      </Row>
      <Box height="1px" background={theme.colors.background} width="100%" mt={4} mb={4} />
      <Text small>{t('Deposit amount')}</Text>
      <DepositAmount amount={formattedAmount} />
      <AutoRow justify="space-between" mt={3}>
        <StyledText small>{t('APR')}</StyledText>
        <Text small>{formatNumber(parseFloat(apr))}%</Text>
      </AutoRow>
      <AutoRow justify="space-between" mt={1}>
        <StyledText small>{t('Multiplier')}</StyledText>
        <Text small>{selectedPool.multiplier / 100}x</Text>
      </AutoRow>
      <AutoRow justify="space-between" mt={1} mb={3}>
        <StyledText small>{t('Period End Date')}</StyledText>
        <Text small>{format(endDate, 'MMM dd, yyyy')}</Text>
      </AutoRow>
      <Warning />
      <ModalActions>
        <Button
          width="100%"
          onClick={onConfirm}
          isLoading={pendingTx}
          endIcon={pendingTx ? <AutoRenewIcon spin color="currentColor" /> : null}
        >
          {t('Confirm Upgrade')}
        </Button>
      </ModalActions>
    </Box>
  )
}

export default ConfirmStep
